import { useEffect } from "react";
import {
  Flex,
  Select,
  FormItem,
  Button,
  Input,
  Text,
  Paragraph,
} from "@/base/components/index";
import { useContextModalHardwareInstall } from "../context/modal-hardware-install-context";
import { LocalizationText } from "@/app/index";
import { Link } from "@/components/link";
import env from "@/app/config/env";
import { useCrSelected } from "../hooks/use-cr-selected";

export const ModalHardwareInstallBusinessUnitCreateActions = () => {
  const isCrSelect = useCrSelected();
  const { form, fetchBackDrawerPage, fetchChangeDrawerPage } =
    useContextModalHardwareInstall();

  const handleButtonClick = () => {
    form.validateFields().then(() => {
      fetchChangeDrawerPage("cr-select");
    });
  };

  const handleDoneClick = () => {
    form.validateFields().then(() => {
      form.submit();
    });
  };

  return (
    <Flex vertical gap={8} align="stretch">
      {!isCrSelect && (
        <Button block size="large" type="primary" onClick={handleDoneClick}>
          <LocalizationText value="modal.hardware.install.button.done.text" />
        </Button>
      )}

      {isCrSelect && (
        <Button block size="large" type="primary" onClick={handleButtonClick}>
          <LocalizationText value="modal.hardware.install.button.continue.text" />
        </Button>
      )}

      <Button
        block
        size="large"
        type="default"
        onClick={() => fetchBackDrawerPage()}
      >
        <LocalizationText value="modal.hardware.install.button.back.text" />
      </Button>
    </Flex>
  );
};

export const ModalHardwareInstallBusinessUnitCreate = () => {
  const { deploymentData, form } = useContextModalHardwareInstall();

  useEffect(() => {
    form.setFieldValue("NewBusinessUnit", true);
  }, []);

  return (
    <Flex vertical align="stretch">
      <FormItem
        rules={[{ required: true, message: "" }]}
        label={
          <LocalizationText value="modal.hardware.install.account.input.label.text" />
        }
        name="BusinessUnitAccountId"
      >
        <Select
          size="large"
          options={deploymentData?.Accounts?.map((item) => ({
            label: item.Name,
            value: item.Id,
          }))}
        />
      </FormItem>

      <FormItem
        rules={[{ required: true, message: "" }]}
        name="BusinessUnitName"
        label={
          <LocalizationText value="modal.hardware.install.business.unit.name.input.label.text" />
        }
      >
        <Input size="large" />
      </FormItem>

      <FormItem
        rules={[{ required: true, message: "" }]}
        name="BusinessUnitAddressLine1"
        label={
          <LocalizationText value="modal.hardware.install.address.input.label.text" />
        }
      >
        <Input size="large" />
      </FormItem>

      <FormItem
        rules={[{ required: true, message: "" }]}
        name="BusinessUnitAddressCity"
        label={
          <LocalizationText value="modal.hardware.install.city.input.label.text" />
        }
      >
        <Input size="large" />
      </FormItem>

      <FormItem
        rules={[{ required: true, message: "" }]}
        name="BusinessUnitAddressStateOrProvince"
        label={
          <LocalizationText value="modal.hardware.install.state.province.input.label.text" />
        }
      >
        <Input size="large" />
      </FormItem>

      <FormItem
        rules={[{ required: true, message: "" }]}
        name="BusinessUnitAddressPostalCode"
        label={
          <LocalizationText value="modal.hardware.install.postal.code.input.label.text" />
        }
      >
        <Input size="large" />
      </FormItem>

      <FormItem
        rules={[{ required: true, message: "" }]}
        name="BusinessUnitPhoneNumber"
        label={
          <LocalizationText value="modal.hardware.install.phone.input.label.text" />
        }
      >
        <Input size="large" />
      </FormItem>

      <FormItem
        rules={[{ required: true, message: "" }]}
        label={
          <LocalizationText value="modal.hardware.install.fuel.brand.input.label.text" />
        }
        name="BusinessUnitFuelBrandId"
      >
        <Select
          size="large"
          options={deploymentData?.FuelBrands?.map((item) => ({
            label: item.Name,
            value: item.Id,
          }))}
        />
      </FormItem>

      <FormItem noStyle shouldUpdate>
        {({ getFieldValue }) => {
          const businessUnitProductId = getFieldValue(`BusinessUnitProductId`);
          const elements = [
            <FormItem key="modal.hardware.install.required.information">
              <Text size="middle" type="danger">
                *{" "}
              </Text>
              <Text size="middle">
                <LocalizationText value="modal.hardware.install.required.information" />
              </Text>
            </FormItem>,
          ];

          if (
            businessUnitProductId !== "e397c87f-a846-eb11-a813-000d3a5a17e3"
          ) {
            return elements;
          }

          return [
            <FormItem key="modal.hardware.install.verifone.required.information">
              <Paragraph>
                <Text size="middle">
                  <LocalizationText value="modal.hardware.install.verifone.required.description.information" />
                </Text>
              </Paragraph>
              <Paragraph>
                <Text size="middle">
                  <LocalizationText value="modal.hardware.install.verifone.required.guide.information" />
                </Text>
              </Paragraph>
              <Paragraph>
                <Link
                  target="_blank"
                  to={`${env.hosts.help}/Content/Cash_Register_Connections/preparing_cash_register_for_cso.htm`}
                >
                  <Text type="primary" size="small">
                    <LocalizationText value="modal.hardware.install.verifone.required.link" />
                  </Text>
                </Link>
              </Paragraph>
            </FormItem>,
            ...elements,
          ];
        }}
      </FormItem>
    </Flex>
  );
};
